import beTwMerge from '@/utils/beTwMerge';
import Title from '@/components/Title/Title';

interface Link {
  label: string;
  href: string;
  isActive?: boolean;
}

interface IMissionNav {
  sectionClass?: string;
  title?: String;
  links?: Link[];
}

export default function MissionNav({ sectionClass, title, links = [] }: IMissionNav) {
  return (
    <section
      className={beTwMerge(
        'tw-flex tw-flex-col tw-items-center tw-bg-color-dark-green-dark tw-py-[56px] large:tw-py-[80px] tw-text-white',
        sectionClass
      )}
    >
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-[24px] tw-px-[16px] large:tw-max-w-fit">
        {title && (
          <div>
            <Title className={beTwMerge('tw-text-white !tw-mb-0 h2b')}>{title}</Title>
          </div>
        )}
        {links.length > 0 && (
          <div className="tw-flex tw-flex-col desktop:tw-flex-row tw-items-center tw-gap-[24px] tw-py-[16px]">
            <div className="tw-flex tw-flex-row tw-flex-wrap tw-justify-center tw-items-center tw-justify-items-center tw-gap-[16px] desktop:tw-gap-[22.6px]">
              {links.map((link, index) => (
                <>
                  <a
                    href={link?.isActive ? undefined : link.href}
                    className="[&_div]:hover:tw-block hover:tw-cursor-pointer tw-text-white tw-text-center h4 tw-relative hover:tw-text-color-light-green-light hover:tw-no-underline"
                    key={index}
                  >
                    <div>{link.label}</div>
                    {link?.isActive && (
                      <div className="tw-absolute tw-w-full tw-py-[2px] tw-bg-color-light-green-light" />
                    )}
                  </a>
                  {index < links.length - 1 && (
                    <div className="tw-w-[1px] tw-h-[21px] tw-mt-[4px] tw-bg-color-light-green-light" />
                  )}
                </>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
